import React from 'react';
import { Typography, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import ComponentHeaderTitles from '../ComponentHeaderTitles';
import { useState } from "react";
import { useEffect } from 'react';
import { FormHelperText } from '@mui/material';
const PersoonsGegevens = ({
    geslacht,
    setGeslacht,
    voornaam,
    setVoornaam,
    achternaam,
    setAchternaam,
    geboorteDatum,
    setGeboorteDatum,
    zakelijk,
    kvkNummer,
    setKvkNummer,
    bedrijfsnaam,
    setBedrijfsnaam,
    onUpdateValidationErrors

}) => {
    const handleGeslachtChange = (event) => {
        const value = event.target.value;
        setGeslacht(value);
    };

    const handleVoornaamChange = (event) => {
        const value = event.target.value;
        setVoornaam(value);
    };

    const handleAchternaamChange = (event) => {
        const value = event.target.value;
        setAchternaam(value);
    };

    const handleGeboorteDatumChange = (event) => {
        const value = event.target.value;
        setGeboorteDatum(value);
    };



    const [aanhefError, setAanhefError] = useState(false);
    const [voornaamError, setVoornaamError] = useState(false);
    const [achternaamError, setAchternaamError] = useState(false);
    const [geboorteDatumError, setGeboorteDatumError] = useState(false);
    const [bedrijfsNaamError, setBedrijfsNaamError] = useState(false);
    const [kvkNummerError, setKvkNummerError] = useState(false);


    /**
     * Only when we have no local errors, we want to clear the validation errors in the parent component.
     * Otherwise, we want to set the validation errors in the parent component.
     */
    useEffect(() => {
        if (!geboorteDatumError && !kvkNummerError && !voornaamError && !achternaamError && !aanhefError && !bedrijfsNaamError && geslacht != null) {
            onUpdateValidationErrors([]);
        } else {
            // If we have local errors, we want to set the validation errors in the parent component.
            geboorteDatumError && onUpdateValidationErrors(['geboorteDatum', false]);
            kvkNummerError && onUpdateValidationErrors(['kvkNummer', false]);
        }
    }, [kvkNummerError, geboorteDatumError, voornaamError, achternaamError, aanhefError, bedrijfsNaamError, geslacht]);


    /**
     * If the user has already filled in the kvkNummer or geboorteDatum, this will be set in the parent state.
     * But if the user goes back a step, then comes back here, the local errors state will be empty and as such,
     * the continue button will be enabled. So we need to check if the user has already filled in the kvkNummer or
     * geboorteDatum and if so, we need to validate them.
     */
    useEffect(() => {
        if (kvkNummer) {
            validateKvkNummerOnBlur({ target: { value: kvkNummer } });
        }
        if (geboorteDatum) {
            handleGeboorteDatumBlur({ target: { value: geboorteDatum } });
        }
    }, []);



    const handleGeboorteDatumBlur = (event) => {
        const value = event.target.value;
        const selectedDate = new Date(value);
        const currentDate = new Date();
        const hundredYearsAgo = new Date(currentDate.getFullYear() - 130, currentDate.getMonth(), currentDate.getDate());
        const eighteenYearsAgo = new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate());
        if (selectedDate < hundredYearsAgo || selectedDate > eighteenYearsAgo) {
            setGeboorteDatumError(true);
        } else {
            setGeboorteDatumError(false);
        }
    };

    const handleKvKNummerChange = (event) => {
        const value = event.target.value;
        const newValue = value.trim() === '' ? null : value;
        const re = /^[0-9\b]+$/;
        if (newValue === '' || re.test(newValue)) {
            setKvkNummer(value);
        }
    };

    const validateKvkNummerOnBlur = (event) => {
        const value = event.target.value;
        const newValue = value.trim() === '' ? null : value;
        const re = /^[0-9]{8}$/;
        const isValid = re.test(newValue);      
        if (isValid) {
            setKvkNummerError(false);
        } else {
            setKvkNummerError(true);
        }
    };



    const handleBedrijfsnaamChange = (event) => {
        const value = event.target.value;
        setBedrijfsnaam(value);
    };

    const handleGenericOnBlur = (event) => {
        const value = event.target.value;
        const field = event.target.name;
        if (value === "") {
            if (field == "voornaam") {
                setVoornaamError(true);
            }
            if (field == "achternaam") {
                setAchternaamError(true);
            }

            if (field == "aanhef") {
                setAanhefError(true);
            }

            if (field == "bedrijfsnaam") {
                setBedrijfsNaamError(true);
            }

        } else {
            if (field == "voornaam") {
                setVoornaamError(false);
            }
            if (field == "achternaam") {
                setAchternaamError(false);
            }

            if (field == "aanhef") {
                setAanhefError(false);
            }

            if (field == "bedrijfsnaam") {
                setBedrijfsNaamError(false);
            }
        }
    };




    const hundredYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 130)).toISOString().split('T')[0];
    const eighteenYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0];


    return (
        <div>
            <ComponentHeaderTitles title="Persoonsgegevens" />

            <div className="gegevens-form">
                <div className="aanhef">
                    <Typography variant="subtitle1" color="textPrimary">
                        <b>Aanhef</b>
                    </Typography>
                    <FormControl style={{ width: '100px' }}>
                        <Select
                            value={geslacht}
                            onChange={handleGeslachtChange}
                            name="aanhef"
                            onBlur={handleGenericOnBlur}
                            error={aanhefError}
                        >
                            <MenuItem value="Dhr">Dhr</MenuItem>
                            <MenuItem value="Mevr">Mevr</MenuItem>
                        </Select>
                        {aanhefError && (
                            <FormHelperText>{'Gelieve je aanhef te selecteren'}</FormHelperText>
                        )}
                    </FormControl>
                </div>

                <div className="voornaam">
                    <Typography variant="subtitle1" color="textPrimary">
                        <b>Voornaam</b>
                    </Typography>
                    <TextField
                        placeholder="Voornaam"
                        type="text"
                        value={voornaam}
                        name="voornaam"
                        onChange={handleVoornaamChange}
                        onBlur={handleGenericOnBlur}
                        error={voornaamError}
                        helperText={voornaamError && 'Gelieve je voornaam in te vullen'}
                    />
                </div>

                <div className="achternaam">
                    <Typography variant="subtitle1" color="textPrimary">
                        <b>Achternaam</b>
                    </Typography>
                    <TextField
                        placeholder="Achternaam"
                        type="text"
                        value={achternaam}
                        name="achternaam"
                        onChange={handleAchternaamChange}
                        onBlur={handleGenericOnBlur}
                        error={achternaamError}
                        helperText={achternaamError && 'Gelieve je achternaam in te vullen'}

                    />
                </div>

                <div className="geboortedatum">
                    <Typography variant="subtitle1" color="textPrimary">
                        <b>Geboortedatum</b>
                    </Typography>
                    <TextField
                        placeholder="DD-MM-YYYY"

                        type="date"
                        value={geboorteDatum}
                        onChange={handleGeboorteDatumChange}
                        onBlur={handleGeboorteDatumBlur}
                        error={geboorteDatumError}
                        helperText={geboorteDatumError && 'Geboortedatum mag niet meer dan 130 jaar geleden zijn of korter dan 18 jaar geleden.'}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            min: hundredYearsAgo,
                            max: eighteenYearsAgo,
                        }}
                    />
                </div>

                {zakelijk == "Zakelijk" && (
                    <>
                        <div className="bedrijfsnaam">
                            <Typography variant="subtitle1" color="textPrimary">
                                <b>Bedrijfsnaam</b>
                            </Typography>
                            <TextField
                                placeholder="Bedrijfsnaam"
                                type="text"
                                name="bedrijfsnaam"
                                value={bedrijfsnaam}
                                onChange={handleBedrijfsnaamChange}
                                onBlur={handleGenericOnBlur}
                                error={bedrijfsNaamError}
                                helperText={bedrijfsNaamError && 'Gelieve je bedrijfsnaam in te vullen'}
                            />
                        </div>

                        <div className="kvknummer">
                            <Typography variant="subtitle1" color="textPrimary">
                                <b>KVK Nummer</b>
                            </Typography>
                            <TextField
                                placeholder="KVK Nummer"
                                type="text"
                                value={kvkNummer}
                                onBlur={validateKvkNummerOnBlur}
                                error={kvkNummerError}
                                helperText={kvkNummerError && 'KvK nummer moet 8 cijfers bevatten.'}
                                onChange={handleKvKNummerChange}
                                inputProps={{ maxLength: 8 }}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

PersoonsGegevens.displayName = 'PersoonsGegevens';
export default PersoonsGegevens;
